import { createStyles } from 'antd-style';

import { ThemeColors } from '../../../theme';

export const useAdminAccountManagementEmptyStyles = createStyles(
  ({ token }) => ({
    empty: {
      color: ThemeColors.COLOR_GREY_BLUISH,
      fontWeight: token.fontWeightStrong,
      fontSize: token.fontSizeHeading2,
      lineHeight: '40px',
    },
  })
);
